<template>
  <div class="newsBody">
    <div class="newsInfo_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span @click="backtop" class="newsInfo_header_bread changeFont">市场风控</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :key="index"
          v-for="(item, index) in newsContentInfo.breadList"
        >
          <span
            class="changeFont"
            @click="backSec(index)"
            :class="!index ? 'secBreadcrumb' : ''"
          >{{ item }}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-skeleton v-if="loading" :rows="20" animated/>
    <div v-else class="newsInfo_warpper">
      <div class="newsInfo_content">
        <div class="title">
          <div class="newsInfo_content_header">
            <div>
              <div
                class="newsInfo_content_header_name"
                v-if="newsInformation.titleFontSize"
                :style="`font-size: ${newsInformation.titleFontSize}`"
              >
                {{ newsInformation.title }}
              </div>
              <div class="newsInfo_content_header_name" v-else>
                {{ newsInformation.title }}
              </div>
            </div>
            <div class="newsInfo_content_instraction1">
              <div class="newsInfo_content_instraction_left">
                <p><span>来源： {{ newsInformation.source }}</span></p>
              </div>
              <div class="newsInfo_content_instraction_right">
                <p><span>发布时间：{{ newsInformation.gmtCreated }}</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="newsInfo_content_instraction">
          <div class="newsInfo_content_instraction_left">
            <p><span>来源： {{ newsInformation.source }}</span></p>
          </div>
          <div class="newsInfo_content_instraction_right">
            <p><span>发布时间：{{ newsInformation.gmtCreated }}</span></p>
          </div>
        </div>
        <div class="newsInfo_content_text" v-html="newsInformation.content"/>
        <div class="fileUrl" v-if="newsInformation.fileUrl">
          <div>
            附件名：<span
              title="点击下载附件"
              @click="fileDownload(getFileName(newsInformation.fileUrl), newsInformation.filename)"
              class="fileUrl_download"
            >{{ newsInformation.filename }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';
import { getNewsInfo, downloadFile } from '@/API/news/news';

export default {
  name: 'newContent',
  props: {
    newsContentInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    newsContentInfo: {
      deep: true,
      immediate: true,
      handler: function (newValue) {
        this.getNewsInfoList(newValue.newsId);
      },
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      newsInformation: {},
      loading: false,
    };
  },
  mounted() {
    scrollTop();
  },
  methods: {
    getNewsInfoList(id) {
      this.loading = true;
      getNewsInfo(id)
        .then((res) => {
          if (res.code === 200) {
            this.newsInformation = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFileName(fileUrl) {
      let name = fileUrl.split('/');
      return name[name.length - 1];
    },
    backtop() {
      this.$emit('goParent', true);
    },
    backSec(index) {
      if (!index) {
        this.$emit('goSecond', this.newsContentInfo);
      }
    },
    fileDownload(fileUrl, filename) {
      downloadFile({ filename: fileUrl })
        .then((res) => {
          if (res) {
            const blob = new Blob([res]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'download.txt';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          } else {
            this.$message.error('下载失败：文件内容为空');
          }
        })
        .catch((error) => {
          this.$message.error('下载失败：' + error.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .scroll {
    padding: 0 10px !important;
  }
  .newsBody {
    width: 100% !important;
    .newsInfo_content_header {
      padding: 0 !important;
      flex-direction: column !important;
    }
    .newsInfo_content {
      padding: 0 5px !important;
      /deep/ .newsInfo_content_text * {
        padding: 10px !important;
        font-size: 14px !important;
        font-weight: 100 !important;
      }
    }
    .changeFont {
      font-size: 14px !important;
    }
    .newsInfo_content_instraction1 {
      display: block !important;
      text-align: center;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #606266;
    }
    .newsInfo_content_instraction {
      display: none !important;
    }
    .newsInfo_content_instraction_left {
      max-width: unset !important;
    }
    .newsInfo_content_header_name {
      width: 100% !important;
      font-size: 18px !important;
      font-weight: bold !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 4 !important;
      line-clamp: 4 !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      word-break: break-all !important;
      white-space: normal !important;
      line-height: 1.5 !important;
    }
    .el-breadcrumb {
      line-height: unset !important;
      .el-breadcrumb__item {
        float: unset;
      }
    }
    .title {
      display: flex;
    }
    .newsInfo_content_text {
      margin-bottom: 0 !important;
    }
  }
}

.newsBody {
  width: 1200px;
  margin: 30px auto;

  .newsInfo_header {
    padding: 20px;

    .newsInfo_header_bread {
      color: #2c3e50;
      font-weight: 600;
      cursor: pointer;
    }

    .changeFont {
      font-size: 16px;
    }

    .newsInfo_header_bread:hover {
      color: #1290e5;
    }
  }

  .newsInfo_content_instraction1 {
    display: none;
  }

  .newsInfo_warpper {
    display: flex;
    justify-content: center;
    height: 100%;
    width: inherit;
    margin-bottom: 100px;
    position: relative;

    .newsInfo_content {
      background: #ffffff;
      padding: 0 100px;
      width: inherit;

      .newsInfo_content_header {
        display: flex;
        justify-content: center;
        padding: 50px 100px 30px 100px;

        .newsInfo_content_header_name {
          width: 100%;
          text-align: center;
          font-size: 32px;
        }
      }

      .newsInfo_content_instraction {
        display: flex;
        justify-content: center;

        .newsInfo_content_instraction_left,
        .newsInfo_content_instraction_right {
          max-width: 250px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #606266;
        }

        .newsInfo_content_instraction_left {
          margin-right: 20px;
        }
      }

      .newsInfo_content_text {
        padding: 0 100px;
        margin-top: 30px;
        margin-bottom: 100px;
        font-family: Hiragino Sans GB, MicroSoft YaHei;
        font-size: 16px;
        line-height: 1.6;
        color: #333;
        text-align: justify;
        text-justify: inter-word;

        p {
          padding: 20px 0;
          text-indent: 2em;
          text-justify: inter-word;
        }
      }

      .fileUrl {
        margin: 20px 0;
        font-size: 16px;
        color: #636565;

        .fileUrl_download {
          text-decoration: underline;
          cursor: pointer;
        }

        .fileUrl_download:hover {
          color: #1da1f2;
        }
      }
    }
  }
}

.secBreadcrumb {
  cursor: pointer;
  font-weight: 500;
}

.secBreadcrumb:hover {
  color: #1976d2;
}
</style>
